import { apiClient, retryRequest } from './httpClient';

// POST request for creating comments
export async function postComment(endpoint, data = null, options = {}) {
    const requestConfig = {
        url: endpoint,
        method: 'POST',
        ...options
    };

    if (data) {
        requestConfig.data = data;
    }

    try {
        const response = await retryRequest(() => apiClient(requestConfig));
        return response.data;
    } catch (error) {
        const err = new Error(error.data || 'POST request failed');
        err.status = error.status || 500;
        err.endpoint = endpoint;
        err.method = 'POST';
        throw err;
    }
}

// GET comment by ID
export async function getCommentById(endpoint, id, options = {}) {
    const requestConfig = {
        url: `${endpoint}/${id}`,
        method: 'GET',
        ...options
    };

    try {
        const response = await retryRequest(() => apiClient(requestConfig));
        return response.data;
    } catch (error) {
        const err = new Error(error.data || 'GET request failed');
        err.status = error.status || 500;
        err.endpoint = endpoint;
        err.method = 'GET';
        throw err;
    }
}

// GET comment list with optional params
export async function getCommentList(endpoint, method = "GET", data = null, options = {}) {
    const requestConfig = {
        url: endpoint,
        method: method.toUpperCase(),
        ...options
    };

    if (data) {
        if (method.toUpperCase() === 'GET') {
            requestConfig.params = data;
        } else {
            requestConfig.data = data;
        }
    }

    try {
        const response = await retryRequest(() => apiClient(requestConfig));
        return response.data;
    } catch (error) {
        const apiError = new Error(error.data || 'API request failed');
        apiError.status = error.status || 500;
        apiError.endpoint = endpoint;
        apiError.method = method;
        throw apiError;
    }
}

// PUT request for updating comments
export async function putComment(endpoint, data = null, options = {}) {
    const requestConfig = {
        url: endpoint,
        method: 'PUT',
        ...options
    };

    if (data) {
        requestConfig.data = data;
    }

    try {
        const response = await retryRequest(() => apiClient(requestConfig));
        return response.data;
    } catch (error) {
        const err = new Error(error.data || 'PUT request failed');
        err.status = error.status || 500;
        err.endpoint = endpoint;
        err.method = 'PUT';
        throw err;
    }
}

// DELETE request for deleting comments
export async function deleteComment(endpoint, id, options = {}) {
    const requestConfig = {
        url: `${endpoint}/${id}`,
        method: 'DELETE',
        ...options
    };

    try {
        const response = await retryRequest(() => apiClient(requestConfig));
        return response.data;
    } catch (error) {
        const err = new Error(error.data || 'DELETE request failed');
        err.status = error.status || 500;
        err.endpoint = endpoint;
        err.method = 'DELETE';
        throw err;
    }
}
